import ReactiveState from '@/ui-kit/hooks/ReactiveState';

const INITIAL_STATE = { searchAddressOptions: [] };

const SoldDataState = new ReactiveState(INITIAL_STATE);

export default SoldDataState;
